import type { LinkToTeamsSignature } from '@efdigital/ll-addon-content/types/components/parts/link-to-teams';
import type { TemplateOnlyComponent } from '@ember/component/template-only';

const LinkToTeams: TemplateOnlyComponent<LinkToTeamsSignature> = <template>
  <a href="#" ...attributes>{{yield}}</a>
</template>;

export { LinkToTeams };
